<script lang="ts">
  import type { PopeProgress } from '$lib/types';
  
  export let pope: PopeProgress;
  
  // Format age at death
  function formatAgeAtDeath(years: number, months: number): string {
    if (months > 0) {
      return `${years} years ${months} months`;
    }
    return `${years} years`;
  }
</script>

<article class="item pope-details">
  <img src={pope.portraitFile} alt={pope.englishName} />

  <div class="pope-content">
    <div>
      <h3>Completed <b class="b-time">{pope.difference}</b> ago</h3>
      <br />
    </div>
    <h2 class="b-name">{pope.englishName}</h2>

    <ul class="papacies-list">
      {#each pope.pope.papacies as papacy}
        <li>
          <ul class={papacy.isAntipapacy ? 'antipapacy' : 'papacy'}>
            <li>
              <span class={papacy.isAntipapacy ? 'antipope-tag' : 'pope-tag'}>
                {papacy.isAntipapacy ? 'Antipope' : 'Pope'} #{papacy.ordinal}
              </span>
              for <b>{papacy.lengthInDays} days</b>
            </li>
            <li>
              <b>{papacy.startDateString} - {papacy.endDateString}</b>
            </li>
          </ul>
        </li>
      {/each}
      <li>Died at <b>{formatAgeAtDeath(pope.pope.yearsAtDeath, pope.pope.monthsAtDeath)}</b></li>
      <li class="small"><a href="/about#date-uncertainty">About date estimates</a></li>
    </ul>

    {#if pope.pope.wikipediaExtract}
      <p>{@html pope.pope.wikipediaExtract}</p>
    {/if}

    <p class="small">
      Extract from <a target="_blank" href={pope.pope.wikipageUrl} rel="noopener noreferrer">Wikipedia &raquo;</a>
    </p>
  </div>
  <div class="clear"></div>
</article>

<style>
  .pope-details {
    text-align: left;
  }

  .pope-details h3 {
    color: #ffffff;
    text-align: left;
    background: #00aa00;
    border-radius: 0;
    padding: 0.5em 1em;
    display: inline-block;
    font-size: 1.5rem;
    box-shadow: #00000044 4px 4px 14px 2px;
    /* Override global h3 styles */
    letter-spacing: normal;
    font-weight: normal;
    text-transform: none;
  }

  .pope-details h3 b {
    color: #ffffff;
    font-weight: bold;
  }

  .pope-details img {
    width: 50%;
    display: block;
    float: left;
    margin: 0 5% 5% 0;
  }

  .pope-details p {
    text-align: left;
    margin-bottom: 1em;
  }

  .pope-details h2 {
    text-align: left;
    margin-bottom: 0.3em;
  }

  .pope-content {
    width: 45%;
    float: right;
  }

  .papacies-list {
    list-style-type: none;
    margin: 0 0 1em 0;
    padding: 0;
  }

  .papacies-list > li {
    padding: 0;
    margin-bottom: 0.3em;
  }

  .pope-tag,
  .antipope-tag {
    color: #ffffff;
    font-weight: bold;
    border-radius: 0.4em;
    display: inline-block;
    text-transform: uppercase;
    font-size: 0.8em;
    padding: 0.1em 0.7em;
    box-shadow: #00000088 1px 1px 1px;
  }

  .pope-tag {
    background-color: #00aa00;
  }

  .antipope-tag {
    background-color: #aa0000;
  }

  .antipapacy,
  .papacy {
    list-style-type: none;
    margin: 0;
    padding: 0 0 0 0.5em;
  }

  .antipapacy {
    border-left: 4px solid #aa0000;
  }

  .papacy {
    border-left: 4px solid #00aa00;
  }

  .antipapacy li,
  .papacy li {
    color: #888888;
    padding: 0;
  }

  .clear {
    clear: both;
  }

  .small {
    font-size: 1rem;
    color: #888888;
  }

  .small a {
    color: #888888;
  }
</style>
